const routes = (module.exports = require("next-routes")());
const { HOME } = require("./urls");
/******************* 
@purpose : Application Routing URL
@Author : INIC
******************/